/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StopBenchmarkRunItemResult } from '../../models/stop-benchmark-run-item-result';

export interface ApiAdminBenchmarkRunItemsItemIdStopPost$Params {
  itemId: string;
}

export function apiAdminBenchmarkRunItemsItemIdStopPost(http: HttpClient, rootUrl: string, params: ApiAdminBenchmarkRunItemsItemIdStopPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StopBenchmarkRunItemResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminBenchmarkRunItemsItemIdStopPost.PATH, 'post');
  if (params) {
    rb.path('itemId', params.itemId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StopBenchmarkRunItemResult>;
    })
  );
}

apiAdminBenchmarkRunItemsItemIdStopPost.PATH = '/api/Admin/benchmark-run-items/{itemId}/stop';
